export class HTTPResponseError extends Error {
    constructor(message: string, public readonly response: Response) {
        super(message);
    }

    public toString(): string {
        return `Got invalid HTTP response with status code:"${
            this.response.status
        }". Error: ${super.toString()}`;
    }
}
